const initialState = {
    tiposDoc: {
      loading: false,
      data: [],
      error: null,
    },
    tiposDocEmpresa: {
      loading: false,
      data: [],
      error: null,
    },
    profesiones: {
      loading: false,
      data: [],
      error: null,
    },
    tiposSolicitudes: {
      loading: false,
      data: [],
      error: null,
    },
    estadosCiviles: {
      loading: false,
      data: [],
      error: null,
    },
    paises: {
      loading: false,
      data: [],
      error: null,
    },
    provincias: {
      loading: false,
      data: [],
      error: null,
    },
    conocio:
    {
      loading: false,
      data: [],
      error: null,
    },
    eligio:
    {
      loading: false,
      data: [],
      error: null,
    },
    nivelEstudioPadres:
    {
      loading: false,
      data: [],
      error: null,
    },
    cue:
    {
      loading: false,
      data: [],
      error: null,
    },
    sms:{
      loading: false,
      data: [],
      error: null,
    },
    verifyMail:{
      loading: false,
      data: [],
      error: null,
    }
  };
  
  const FormDataReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'LOAD_TIPODOC_REQUEST':
        return {
          ...state,
          tiposDoc: {
            ...state.tiposDoc,
            loading: true,
            error: null,
          },
        };
  
      case 'LOAD_TIPODOC_SUCCESS':
        return {
          ...state,
          tiposDoc: {
            ...state.tiposDoc,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_TIPODOC_FAIL':
        return {
          ...state,
          tiposDoc: {
            ...state.tiposDoc,
            loading: false,
            error: action.payload,
          },
        };
  
      case 'LOAD_PROFESIONES_REQUEST':
        return {
          ...state,
          profesiones: {
            ...state.profesiones,
            loading: true,
            error: null,
          },
        };
  
      case 'LOAD_PROFESIONES_SUCCESS':
        return {
          ...state,
          profesiones: {
            ...state.profesiones,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_PROFESIONES_FAIL':
        return {
          ...state,
          profesiones: {
            ...state.profesiones,
            loading: false,
            error: action.payload,
          },
        };

      case 'LOAD_TIPO_PROFESIONES_REQUEST':
        return {
          ...state,
          tiposSolicitudes: {
            ...state.tiposSolicitudes,
            loading: true,
            error: null,
          },
        };
  
      case 'LOAD_TIPO_PROFESIONES_SUCCESS':
        return {
          ...state,
          tiposSolicitudes: {
            ...state.tiposSolicitudes,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_TIPO_PROFESIONES_FAIL':
        return {
          ...state,
          tiposSolicitudes: {
            ...state.tiposSolicitudes,
            loading: false,
            error: action.payload,
          },
        };
  
      case 'LOAD_ESTADOCIVIL_REQUEST':
        return {
          ...state,
          estadosCiviles: {
            ...state.estadosCiviles,
            loading: true,
            error: null,
          },
        };
  
      case 'LOAD_ESTADOCIVIL_SUCCESS':
        return {
          ...state,
          estadosCiviles: {
            ...state.estadosCiviles,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_ESTADOCIVIL_FAIL':
        return {
          ...state,
          estadosCiviles: {
            ...state.estadosCiviles,
            data: [],
            loading: false,
            error: action.payload,
          },
        };
  
        case 'LOAD_PAISES_REQUEST':
            return {
              ...state,
              paises: {
                ...state.paises,
                loading: true,
                error: null,
              },
            };
  
      case 'LOAD_PAISES_SUCCESS':
        return {
          ...state,
          paises: {
            ...state.paises,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_PAISES_FAIL':
        return {
          ...state,
          paises: {
            ...state.paises,
            loading: false,
            error: action.payload,
          },
        };

      case 'LOAD_PROVINCIAS_REQUEST':
          return {
            ...state,
            provincias: {
              ...state.provincias,
              loading: true,
              error: null,
            },
          };
  
      case 'LOAD_PROVINCIAS_SUCCESS':
        return {
          ...state,
          provincias: {
            ...state.provincias,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_PROVINCIAS_FAIL':
        return {
          ...state,
          provincias: {
            ...state.provincias,
            loading: false,
            error: action.payload,
          },
        };


        case 'LOAD_CONOCIO_REQUEST':
            return {
              ...state,
              conocio: {
                ...state.conocio,
                loading: true,
                error: null,
              },
            };
  
      case 'LOAD_CONOCIO_SUCCESS':
        return {
          ...state,
          conocio: {
            ...state.conocio,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_CONOCIO_FAIL':
        return {
          ...state,
          conocio: {
            ...state.conocio,
            loading: false,
            error: action.payload,
          },
        };


        case 'LOAD_ELIGIO_REQUEST':
          return {
            ...state,
            eligio: {
              ...state.eligio,
              loading: true,
              error: null,
            },
          };
    
        case 'LOAD_ELIGIO_SUCCESS':
          return {
            ...state,
            eligio: {
              ...state.eligio,
              loading: false,
              error: null,
              data: action.payload,
            },
          };
    
        case 'LOAD_ELIGIO_FAIL':
          return {
            ...state,
            eligio: {
              ...state.eligio,
              loading: false,
              error: action.payload,
            },
          };

          case 'LOAD_NIVELESTUDIOP_REQUEST':
          return {
            ...state,
            nivelEstudioPadres: {
              ...state.nivelEstudioPadres,
              loading: true,
              error: null,
            },
          };
    
        case 'LOAD_NIVELESTUDIOP_SUCCESS':
          return {
            ...state,
            nivelEstudioPadres: {
              ...state.nivelEstudioPadres,
              loading: false,
              error: null,
              data: action.payload,
            },
          };
    
        case 'LOAD_NIVELESTUDIOP_FAIL':
          return {
            ...state,
            nivelEstudioPadres: {
              ...state.nivelEstudioPadres,
              loading: false,
              error: action.payload,
            },
          };


          case 'LOAD_CUE_REQUEST':
            return {
              ...state,
              cue: {
                ...state.cue,
                loading: true,
                error: null,
              },
            };
      
          case 'LOAD_CUE_SUCCESS':
            return {
              ...state,
              cue: {
                ...state.cue,
                loading: false,
                error: null,
                data: action.payload,
              },
            };
      
          case 'LOAD_CUE_FAIL':
            return {
              ...state,
              cue: {
                ...state.cue,
                loading: false,
                error: action.payload,
                data:[]
              },
            };

            case 'SEND_SMS_REQUEST':
              return {
                ...state,
                verifySMS: { loading: true, error: null, success: false },
              };
        
            case 'SEND_SMS_SUCCESS':
              return {
                ...state,
                verifySMS: { loading: false, error: null, success: true },
              };
        
            case 'SEND_SMS_FAIL':
              return {
                ...state,
                verifySMS: { loading: false, error: action.payload, success: false },
              };

            case 'VERIFY_SMS_REQUEST':
              return {
                ...state,
                verifySMS: { loading: true, error: null, success: false },
              };
        
            case 'VERIFY_SMS_SUCCESS':
              return {
                ...state,
                verifySMS: { loading: false, error: null, success: true },
              };
        
            case 'VERIFY_SMS_FAIL':
              return {
                ...state,
                verifySMS: { loading: false, error: action.payload, success: false },
              };

        case 'LOAD_TIPODOC_REQUESTEMPRESAS':
        return {
          ...state,
          tiposDocEmpresa: {
            ...state.tiposDocEmpresa,
            loading: true,
            error: null,
          },
        };
  
      case 'LOAD_TIPODOC_SUCCESSEMPRESAS':
        return {
          ...state,
          tiposDocEmpresa: {
            ...state.tiposDocEmpresa,
            loading: false,
            error: null,
            data: action.payload,
          },
        };
  
      case 'LOAD_TIPODOC_FAILEMPRESAS':
        return {
          ...state,
          tiposDocEmpresa: {
            ...state.tiposDocEmpresa,
            loading: false,
            error: action.payload,
          },
        };


        case 'SEND_MAIL_VALIDATION_REQUEST':
              return {
                ...state,
                verifyMail: { loading: true, error: null, success: false },
              };
        
            case 'SEND_MAIL_VALIDATION_SUCCESS':
              return {
                ...state,
                verifyMail: { loading: false, error: null, success: true },
              };
        
            case 'SEND_MAIL_VALIDATION_FAIL':
              return {
                ...state,
                verifyMail: { loading: false, error: action.payload, success: false },
              };

            case 'VERIFY_MAIL_VALIDATION_REQUEST':
              return {
                ...state,
                verifyMail: { loading: true, error: null, success: false },
              };
        
            case 'VERIFY_MAIL_VALIDATION_SUCCESS':
              return {
                ...state,
                verifyMail: { loading: false, error: null, success: true },
              };
        
            case 'VERIFY_MAIL_VALIDATION_FAIL':
              return {
                ...state,
                verifyMail: { loading: false, error: action.payload, success: false },
              };

      default:
        return state;
    }
  };
  
  export default FormDataReducer;
  